/**
 * Employee Web — `/me/loans` landing index route.
 *
 * Renders the loans landing (active loans + pending requests) under the
 * pathless `_auth.me.loans` parent. Permission gate: `loan:read:self`.
 */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { requirePermission } from "@linkhr/auth";
import { MeLoansLanding } from "../features/loans/MeLoansLanding";

export const Route = createFileRoute("/_auth/me/loans/")({
  beforeLoad: requirePermission({
    anyOf: ["loan:read:self"],
    defaultRoute: "/me/overview",
  }),
  component: MeLoansIndexRoute,
});

function MeLoansIndexRoute(): JSX.Element {
  return <MeLoansLanding />;
}
